import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {AllLocationResponse, AllLocationResponsePagination} from "../../models/location.types";
import {PageEvent} from "@angular/material/paginator";
import {LocationService} from "../../services/location.service";

@Component({
    selector: 'app-select-location-dialog',
    templateUrl: './select-location-dialog.component.html'
})
export class SelectLocationDialogComponent implements OnInit {
    locationName = '';
    allLocationPageable: AllLocationResponsePagination;
    pageNumber = 0;
    allLocations: AllLocationResponse[];
    failedLogoIds = new Set<string>();

    constructor(private matDialog: MatDialog,
                private locationService: LocationService,
                private dialogRef: MatDialogRef<SelectLocationDialogComponent>,) {
    }

    ngOnInit() {
        this.searchLocation();
    }

    closeDialog() {
        this.matDialog.closeAll();
    }

    searchLocation() {
        this.locationService.fetchAllLocationForOrgUserV2(this.locationName, this.pageNumber).subscribe({
            next: (res) => {
                this.allLocationPageable = res;
                this.allLocations = res.locationListResList;
            }
        });
    }

    clearSearchText() {
        if (this.locationName) {
            this.locationName = '';
            this.searchLocation();
        }
    }

    getNextLocations($event: PageEvent) {
        this.pageNumber = $event.pageIndex;
        this.searchLocation();
    }

    setLocation(location: AllLocationResponse) {
        this.dialogRef.close(location);
    }

    hasLocationLogo(location: AllLocationResponse): boolean {
        return !!location.logoURL?.trim() && !this.failedLogoIds.has(location.locationId);
    }

    onLogoError(locationId: string): void {
        this.failedLogoIds.add(locationId);
    }

    getLocationInitial(location: AllLocationResponse): string {
        return location.name?.trim()?.[0]?.toUpperCase() || '?';
    }
}
